import { useEffect, useState } from 'preact/hooks';
function usePermissionCheck(callback, permission) {
  const [times, setTimes] = useState(0);
  function onPermissionResponse(event) {
    const eventData = event.detail.eventData;
    if (permission !== eventData.permission) {
      return;
    }
    setTimes(prevState => {
      const newTimes = prevState + 1;
      callback(eventData, newTimes);
      return newTimes;
    });
  }
  useEffect(() => {
    document.addEventListener(
      window.__CAAS__.events.requestPermission,
      onPermissionResponse,
    );
    return () => {
      document.removeEventListener(
        window.__CAAS__.events.requestPermission,
        onPermissionResponse,
      );
    };
  }, []);
}
export default usePermissionCheck;
